// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".floorPlanImportModal .ui.card {\n  position: relative;\n}\n.floorPlanImportModal .ui.card .ui.checkbox {\n  position: absolute;\n  top: 7px;\n  left: 10px;\n}\n.floorPlanImportModal .content .description {\n  min-height: 400px;\n}\n.floorPlanImportModal .ui.label {\n  position: absolute;\n  top: 7px;\n  left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
